import {EnvGlobalsHandler} from "../../EnvGlobalsHandler";
import {IEnvironmentGlobals} from "../../IEnvironmentGlobals";
import {BasicController} from "../BasicController";
import {ConnectionTrackingUtil} from "../../tracking/ConnectionTrackingUtil";
import {CommandController} from "./../../../commanding/CommandController";
import {SimpleCommand} from "./../../../commanding/SimpleCommand";
import {getLogger} from "@goodgamestudios/logger";
/**
 * Created with IntelliJ IDEA.
 * User: nzamuruev
 * Date: 25.06.13
 * Time: 15:53
 * To change this template use File | Settings | File Templates.
 */

const logger = getLogger("BasicTrackRegistrationDataCommand");

export class BasicTrackRegistrationDataCommand extends SimpleCommand {
    protected wasExecuted: boolean = false;

    public execute(commandVars: any = null): void {
        if (this.wasExecuted) {
            return;
        }
        logger.warn("FIRST INSTANCE TRACKING WAS RETIRED --  REPLACE TRACKING WITH CLIENTFUNNEL?");
        // //----
        // let trackingEvent: FirstInstanceTrackingEvent = (<FirstInstanceTrackingEvent>TrackingCache.getInstance().getEvent(TrackingEventIds.FIRST_INSTANCE));
        // this.env.isRegistered = true;
        // trackingEvent.registered = 1;
        // trackingEvent.playerId = BasicModel.userData.playerID;
        // //----

        if (this.env.doUserTunnelTracking) {
            // Executes delayed round trip on SmartfoxClient after about 60s (will be tracked automatically afterwards)
            ConnectionTrackingUtil.instance.measureRTT(ConnectionTrackingUtil.SECOND_CONNECTION_EVENT_DELAY);
            ConnectionTrackingUtil.instance.measureRTT(ConnectionTrackingUtil.THIRD_CONNECTION_EVENT_DELAY);
            //				BasicModel.smartfoxClient.performPolicyPingTest();
        }

        CommandController.instance.executeCommand(BasicController.COMMAND_TRACK_DESKTOP_DEVICE_INFORMATION_EVENT);

        this.wasExecuted = true;
    }

    protected get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }
}

